import { AssessmentHistory } from "@/interface/userAssessment";
import { API_BASE_URL } from "@/utils/api";
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export const useAssessment = () => {
  const navigate = useNavigate();
  const [assessments, setAssessments] = useState<AssessmentHistory[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchHistory = async () => {
      const storedUser = localStorage.getItem("user");

      if (!storedUser) {
        navigate("/auth/Login");
        return;
      }

      const parsedUser = JSON.parse(storedUser);

      try {
        const response = await axios.get(
          `${API_BASE_URL}/quiz/history/${parsedUser.id}`,
        );

        const sortedData = response.data.sort(
          (a: AssessmentHistory, b: AssessmentHistory) =>
            new Date(b.created_at).getTime() - new Date(a.created_at).getTime(),
        );

        setAssessments(sortedData);
      } catch (err) {
        console.error("Failed to fetch history:", err);
        setError(
          "Failed to load exam history. Please ensure the backend server is running.",
        );
      } finally {
        setIsLoading(false);
      }
    };

    fetchHistory();
  }, [navigate]);

  return {
    assessments,
    isLoading,
    error,
  };
};
